var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 240,
    viewBox: "0 0 258 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9372 50.0132C80.1912 48.8383 80.3242 47.6149 80.3242 46.3552C80.3242 36.5924 72.4272 28.6829 62.6921 28.6829C52.9569 28.6829 45.0479 36.5924 45.0479 46.3552C45.0479 56.118 52.9448 64.0276 62.6921 64.0276C64.107 64.0276 65.4977 63.858 66.8159 63.531",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.529 176.845V202.1",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.13 189.478H228.915",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.659 175.452C150.659 181.775 142.194 182.78 128.105 182.78C122.349 182.78 117.681 173.853 117.681 162.843C117.681 161.534 117.741 160.25 117.874 159.015C118.805 149.846 123.038 142.917 128.105 142.917C133.874 142.917 138.542 151.844 138.542 162.843C138.542 164.151 138.481 165.435 138.336 166.67C138.082 169.25 137.562 171.636 136.837 173.756",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3646 167.373C66.4409 164.235 67.0698 160.493 67.0698 156.459C67.0698 145.449 62.4018 136.522 56.6453 136.522C50.8889 136.522 46.2208 145.449 46.2208 156.459C46.2208 167.47 50.8889 176.397 56.6453 176.397C67.3721 176.397 79.1994 175.391 79.1994 169.068",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0916 158.772L107.123 162.406",
    stroke: "#1A4078",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.615 166.064L170.202 168.596L239.981 160.359C247.588 159.463 253.32 152.995 253.32 145.328",
    stroke: "#1A4078",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.132 138.423C188.33 141.209 185.416 143.026 182.126 143.026C176.648 143.026 172.198 138 172.198 131.786C172.198 125.572 176.636 120.545 182.126 120.545C186.468 120.545 190.168 123.707 191.511 128.116",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.412 132.452C253.61 135.238 250.696 137.055 247.406 137.055C241.928 137.055 237.478 132.028 237.478 125.814C237.478 119.6 241.916 114.573 247.406 114.573C251.748 114.573 255.448 117.735 256.791 122.144",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.836 63.0828L144.214 110.589L196.082 108.033",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4373 78.4049C35.5329 69.6048 22.0013 81.1132 22.0013 81.1132",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0287 90.5041C46.1945 89.5511 42.7881 97.9633 42.7881 97.9633",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.314 74.1172L157.383 97.5309",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.502 89.7305L172.294 99.6871",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M237.478 111.824L207.232 105.61L188.475 63.9064C187.109 58.1771 181.908 54.2042 176.031 54.3859L84.1336 57.3656C78.3287 57.5594 73.443 61.7504 72.3667 67.4675L63.4539 112.333H40.9119C36.3768 112.333 32.8335 116.269 33.3172 120.8L37.1145 156.471",
    stroke: "#1A4078",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4121 63.8337L99.601 110.589H78.2441",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.96 110.588H127.15",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M205.902 130.005L226.049 128.661",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M205.902 137.212L226.049 135.868",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.941 54.8097C233.207 54.8097 241.529 46.4745 241.529 36.1926C241.529 25.9106 233.207 17.5754 222.941 17.5754C212.676 17.5754 204.354 25.9106 204.354 36.1926C204.354 46.4745 212.676 54.8097 222.941 54.8097Z",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M222.941 9.62947V1.21118",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M222.941 9.62947V1.21118",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M199.964 22.9171L192.696 18.7019",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.964 49.48L192.696 53.6831",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M222.941 62.7676V71.1738",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M245.907 49.48L253.187 53.6831",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M245.907 22.9171L253.187 18.7019",
    stroke: "#FACC15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.871 148.162L175.898 154.618C166.659 155.429 167.735 160.589 167.735 160.589",
    stroke: "#1A4078",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.659 116.136L166.441 120.545",
    stroke: "#68B1E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelLight);
export default __webpack_public_path__ + "static/media/TravelLight.7a2fddaacd76e28544765523bc912c96.svg";
export { ForwardRef as ReactComponent };